import { login, logout } from '@/api/user';
import { getToken, setToken, removeToken, removeRoles } from '@/utils/auth';

const state = {
    token: getToken(),
    roles: '',
    userInfo: {},
    areaMap: [],
    curActiveChatId: '', // 当前活跃的房间号
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles;
    },
    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo;
    },
    REMOVE_TOKEN: (state) => {
        state.token = null;
    },
    Set_Active_Chat_Id: (state, curActiveChatId) => {
        // console.log("user-store mutation Set_Active_Chat_Id", { curActiveChatId });
        state.curActiveChatId = curActiveChatId;
    },
};

const actions = {
    // 登录
    login({ commit }, userInfo) {
        const { username, password } = userInfo;
        console.log('redux action login');
        return new Promise((resolve, reject) => {
            login({ username: username.trim(), password })
                .then((response) => {
                    if (response.code === 0) {
                        const { access_token } = response.data;
                        // 放到 vuex store 里
                        commit('SET_TOKEN', access_token);

                        // 放到 localStorage 的 Cookies 里面
                        setToken(access_token);

                        // userInfo 放到 store 里
                        // commit("SET_USERINFO", userInfo);

                        // userInfo 放到 localStorage 的 cookie 里
                        // setUserInfo(userInfo);

                        resolve();
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    // 权限
    getUserRoles({ commit }) {
        return new Promise((resolve) => {
            const response = {
                authorities: [
                    'paper_search',
                    'company_compare',
                    'industry_map',
                    'generic',
                    'patent_evaluation',
                    'report_company_compare_evaluation',
                    'company_search_advanced',
                    'report_company_evaluation',
                    'talent_evaluation',
                    'company_top_list',
                    'industry_chain',
                    'talent_search',
                    'paper_info',
                    'paper_search_advanced',
                    'talent_search_advanced',
                    'company_identification',
                    'patent_search_advanced',
                    'company_search',
                    'decision',
                    'industry_search',
                    'report_patent_evaluation',
                    'area_map',
                    'industry_search_advanced',
                    'patent_search',
                ],
            };
            commit('SET_ROLES', JSON.stringify(response));
            // setRoles(JSON.stringify(response));
            resolve();
        });
    },

    // 退出
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            logout(state.token)
                .then(() => {
                    commit('SET_TOKEN', '');
                    // commit('SET_ROLES', '');
                    removeToken();
                    removeRoles();
                    resolve();
                })
                .catch((error) => {
                    commit('SET_TOKEN', '');
                    // commit('SET_ROLES', '');
                    removeToken();
                    removeRoles();
                    reject(error);
                });
        });
    },

    // 401 清除信息
    clearInfo({ commit }) {
        return new Promise((resolve, reject) => {
            commit('SET_TOKEN', '');
            // commit('SET_ROLES', '');
            removeToken();
            removeRoles();
            reject('error');
        });
    },

    // 从 vuex 中移除 cookie
    removeToken({ commit }) {
        return new Promise((resolve) => {
            commit('REMOVE_TOKEN');
            resolve();
        });
    },

    setActiveChatId({ commit }, activeChatId) {
        return new Promise((resolve) => {
            commit('Set_Active_Chat_Id', activeChatId);
            resolve();
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js